// TSV export worker
function tsvExport() {

    const SKOS = "http://www.w3.org/2004/02/skos/core#";
    const OWL = "http://www.w3.org/2002/07/owl#";

    onmessage = function (message) {
        const { id, data, options, template, mode, format } = message.data;
        let tsvData = mode === "conceptScheme" ?
            tsvSchemeFunction(id, data, options, template, format)
            :
            mode === "concept" ?
                tsvConceptFunction(id, data, options, template, format) :
                mode === "dataset" ?
                    tsvDatasetFunction(id, data, options, template, format)
                    :
                    tsvCollectionFunction(id, data, options, template, format);
        postMessage(tsvData);
        // Clear the data
        tsvData = undefined;
    };

    function computeNumericSortValue(value) {
        let orderValue = 0;
        if (value !== undefined) orderValue = Array.isArray(value) ?
            value.length === 0 ?
                0
                :
                value.map(v => typeof v === "number" ?
                    v
                    :
                    typeof v === "string" || typeof v === "boolean" ?
                        Number(v)
                        :
                        "@value" in v ?
                            Number(v["@value"])
                            :
                            v).sort()[0]
            :
            typeof value === "number" ?
                value
                :
                typeof value === "string" || typeof value === "boolean" ?
                    Number(value)
                    :
                    "@value" in value ?
                        Number(value["@value"])
                        :
                        Number(value);
        if (isNaN(orderValue)) orderValue = undefined;
        return orderValue;
    }

    function computeStringSortValue(value, lang) {
        let orderValue = "";
        if (value !== undefined) orderValue = Array.isArray(value) ?
            value.length === 0 ?
                ""
                :
                value
                    .filter(v => v.language ? v.language === lang : true)
                    .map(v => typeof v === "number" || typeof v === "boolean" ?
                        v.toString()
                        :
                        typeof v === "string" ?
                            v
                            :
                            "@value" in v ?
                                v["@value"]
                                :
                                "id" in v ?
                                    v["id"]
                                    :
                                    v).sort()[0]
            :
            typeof value === "number" || typeof value === "boolean" ?
                value.toString()
                :
                typeof value === "string" ?
                    value
                    :
                    "@value" in value ?
                        "language" in value ?
                            value.language === lang ?
                                value["@value"]
                                :
                                undefined
                            :
                            value["@value"]
                        :
                        "id" in value ?
                            value["id"]
                            :
                            value.toString();
        return orderValue;
    }

    function sortByAnyProp(resourceLookup, objects, property, numeric, lang = "en") {
        return objects.sort(function (a, b) {
            const aData = resourceLookup[a];
            const bData = resourceLookup[b];
            let orderA = "";
            let orderB = "";
            if (numeric) {
                // For arrays take lowest value
                orderA = computeNumericSortValue(aData[property]);
                orderB = computeNumericSortValue(bData[property]);
                if (orderA === undefined) orderA = 0;
                if (orderB === undefined) orderB = 0;
                if (orderA < orderB) return -1;
                if (orderA > orderB) return 1;
            }
            else {
                orderA = computeStringSortValue(aData[property], lang);
                orderB = computeStringSortValue(bData[property], lang);
                if (orderA === undefined) orderA = "";
                if (orderB === undefined) orderB = "";
                if (orderA.toLowerCase() < orderB.toLowerCase()) return -1;
                if (orderA.toLowerCase() > orderB.toLowerCase()) return 1;
            }
            return 0;
        });
    }

    function sortConcepts(resourceLookup, concepts, lang, customProp, sortNumerically = false) {
        let sortedConcepts = concepts.sort((a, b) => {
            const aConcept = resourceLookup[a]; //data.graph.find(item => item.id === a);
            const bConcept = resourceLookup[b]; //data.graph.find(item => item.id === b);
            // toString to handle multiple pref labels in same language
            const aText = aConcept && aConcept.prefLabel && aConcept.prefLabel[lang] ?
                Array.isArray(aConcept.prefLabel[lang]) ?
                    aConcept.prefLabel[lang].sort().toString().toLowerCase()
                    :
                    aConcept.prefLabel[lang].toString().toLowerCase()
                :
                "";
            const bText = bConcept && bConcept.prefLabel && bConcept.prefLabel[lang] ?
                Array.isArray(bConcept.prefLabel[lang]) ?
                    bConcept.prefLabel[lang].sort().toString().toLowerCase()
                    :
                    bConcept.prefLabel[lang].toString().toLowerCase()
                :
                "";
            if (aText < bText) return -1;
            return 1;
        });
        if (customProp) {
            const fullySortedConcepts = sortByAnyProp(resourceLookup, sortedConcepts, customProp, sortNumerically, lang);
            return fullySortedConcepts;
        }
        return sortedConcepts;
    }

    function sortResource(dataItems, lang) {
        dataItems.forEach(resource => {
            // toString to handle multiple labels in same language
            const text = resource && resource.label && resource.label[lang] ?
                Array.isArray(resource.label[lang]) ?
                    resource.label[lang].sort().toString().toLowerCase()
                    :
                    resource.label[lang].toString().toLowerCase()
                :
                "";
            resource.sortValue = text;
        });
        return dataItems.sort((a, b) => {
            if (a.sortValue < b.sortValue) return -1;
            return 1;
        });
    }

    function processNarrower(rows, data, resourceLookup, parentConcept, lang, circular = [], indent = 1, customProp, sortNumerically) {
        sortConcepts(resourceLookup, parentConcept.narrower, lang, customProp, sortNumerically)
            .forEach(concept => {
                if (!circular.includes(concept)) {
                    const conceptData = resourceLookup[concept];
                    let row = [concept];
                    for (let i = 0; i < indent; i++) { row.push(null); }
                    const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                        conceptData.prefLabel[lang]
                        :
                        'No value in selected language';
                    row.push(label);
                    rows.push(row);
                    const newCircular = circular.slice();
                    newCircular.push(concept);
                    if (conceptData && conceptData.narrower) processNarrower(rows, data, resourceLookup, conceptData, lang, newCircular, indent + 1, customProp, sortNumerically);
                }
            });
    }

    function computeConceptRows(conceptData, properties, languages) {
        let rowCount = 1;
        if (!conceptData) return rowCount;
        properties.forEach((prop, propIndex) => {
            const alias = prop.indexOf(SKOS) === 0 ?
                prop.substring(SKOS.length)
                :
                prop.indexOf(OWL) === 0 ?
                    prop.substring(OWL.length)
                    :
                    prop === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" ?
                        "type"
                        :
                        prop;
            const data = conceptData[alias];
            if (data) {
                if (Array.isArray(data)) {
                    // We only want language values for this column (there may be multiple languages)
                    if (data[0]["language"]) {
                        const columnLang = languages[propIndex];
                        const columnValues = data.filter(item => item.language === columnLang);
                        if (columnValues.length > rowCount) rowCount = columnValues.length;
                    }
                    else {
                        if (data.length > rowCount) rowCount = data.length;
                    }
                }
                else if (typeof data === 'object') {
                    if (data["id"]) {
                        // Do nothing for now as should only be one value - i.e one row
                    }
                    else {
                        const langItems = data[languages[propIndex]];
                        const langItemsLength = Array.isArray(langItems) ? langItems.length : 1;
                        if (langItemsLength > rowCount) rowCount = langItemsLength;
                    }
                }
            }
        });
        return rowCount;
    }

    function getResourcesFromData(data) {
        let resources = {};
        if (data.graph) {
            data.graph.forEach(item => resources[item.id] = item);
        }
        return resources;
    }

    function computeAdditionalRows(data, rows, properties, languages, format, resourceName, referencesAsLabels = false) {
        let rowsWithContent = [];
        const resourceLookup = getResourcesFromData(data);
        const refProp = resourceName === "Resource" ? "label" : "prefLabel";
        rows.forEach(row => {
            const rowLength = row.length;
            const concept = row[0];
            const conceptData = resourceLookup[concept];
            const rowCount = computeConceptRows(conceptData, properties, languages);
            // Add columns for properties
            for (let i = 1; i < properties.length; i++) { row.push(null); }
            const rowIndex = rowsWithContent.length;
            rowsWithContent.push(row);
            if (rowCount > 1) {
                // Add additional rows to handle multiple values on a property
                for (let i = 1; i < rowCount; i++) {
                    const additionalRow = [];
                    // Pad out new row for all needed columns
                    for (let j = 1; j < row.length + properties.length; j++) { additionalRow.push(null); }
                    rowsWithContent.push(additionalRow);
                }
            }
            // Now populate additional property data
            properties.forEach((prop, propIndex) => {
                const alias = prop.indexOf(SKOS) === 0 ?
                    prop.substring(SKOS.length)
                    :
                    prop.indexOf(OWL) === 0 ?
                        prop.substring(OWL.length)
                        :
                        prop === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" ?
                            "type"
                            :
                            prop;
                const propData = conceptData ? conceptData[alias] : null;
                const columnLang = languages[propIndex];

                if (propData !== null) {
                    if (Array.isArray(propData)) {
                        propData
                            // If language values filter for this column
                            .filter(dataValue => !dataValue["language"] || dataValue["language"] === columnLang)
                            .sort((a, b) => {
                                let valueA = a["id"] ?
                                    a["id"]
                                    :
                                    a["@value"] ?
                                        a["@value"]
                                        :
                                        a;
                                let valueB = b["id"] ?
                                    b["id"]
                                    :
                                    b["@value"] ?
                                        b["@value"]
                                        :
                                        b;
                                if (referencesAsLabels) {
                                    if (a["id"]) {
                                        let dataValueText = a["id"];
                                        if (resourceLookup[dataValueText]) {
                                            const refData = resourceLookup[dataValueText];
                                            if (refProp in refData) {
                                                const refLang = Object.keys(refData[refProp]);
                                                valueA = escapeText(refData[refProp][refLang].toString(), format);
                                            }
                                        }
                                    }
                                    else {
                                        if (valueA.startsWith("http") && resourceLookup[valueA]) {
                                            const refData = resourceLookup[valueA];
                                            if (refProp in refData) {
                                                const refLang = Object.keys(refData[refProp]);
                                                valueA = escapeText(refData[refProp][refLang].toString(), format);
                                            }
                                        }

                                    }
                                    if (b["id"]) {
                                        let dataValueText = b["id"];
                                        if (resourceLookup[dataValueText]) {
                                            const refData = resourceLookup[dataValueText];
                                            if (refProp in refData) {
                                                const refLang = Object.keys(refData[refProp]);
                                                valueB = escapeText(refData[refProp][refLang].toString(), format);
                                            }
                                        }
                                    }
                                    else {
                                        if (valueB.startsWith("http") && resourceLookup[valueB]) {
                                            const refData = resourceLookup[valueB];
                                            if (refProp in refData) {
                                                const refLang = Object.keys(refData[refProp]);
                                                valueB = escapeText(refData[refProp][refLang].toString(), format);
                                            }
                                        }

                                    }
                                }
                                return valueA < valueB ? -1 : 1;
                            })
                            .forEach((dataValue, dataValueIndex) => {
                                if (dataValue["id"]) {
                                    let dataValueText = dataValue["id"];
                                    if (referencesAsLabels && resourceLookup[dataValueText]) {
                                        const refData = resourceLookup[dataValueText];
                                        if (refProp in refData) {
                                            const refLang = Object.keys(refData[refProp]);
                                            dataValueText = escapeText(refData[refProp][refLang].toString(), format);
                                        }
                                    }
                                    rowsWithContent[rowIndex + dataValueIndex][rowLength + propIndex] = dataValueText;
                                }
                                else {
                                    let cleanedUpText = dataValue["@value"] ?
                                        escapeText(dataValue["@value"], format)
                                        :
                                        typeof dataValue === "string" ?
                                            escapeText(dataValue, format)
                                            :
                                            dataValue;
                                    // If outputting labels for IRIs check if exists
                                    if (referencesAsLabels && cleanedUpText.startsWith("http") && resourceLookup[cleanedUpText]) {
                                        const refData = resourceLookup[cleanedUpText];
                                        if (refProp in refData) {
                                            const refLang = Object.keys(refData[refProp]);
                                            cleanedUpText = escapeText(refData[refProp][refLang].toString(), format);
                                        }
                                    }
                                    rowsWithContent[rowIndex + dataValueIndex][rowLength + propIndex] = cleanedUpText;
                                }
                            });
                    }
                    else if (typeof propData === 'object') {
                        if (propData["id"]) {
                            let dataValueText = propData["id"];
                            if (referencesAsLabels && resourceLookup[dataValueText]) {
                                const refData = resourceLookup[dataValueText];
                                if (refProp in refData) {
                                    const refLang = Object.keys(refData[refProp]);
                                    dataValueText = escapeText(refData[refProp][refLang].toString(), format);
                                }
                            }
                            rowsWithContent[rowIndex][rowLength + propIndex] = dataValueText;
                        }
                        else if (propData["@value"]) {
                            const cleanedUpText = typeof propData["@value"] === "string" ?
                                escapeText(propData["@value"], format)
                                :
                                propData["@value"];
                            rowsWithContent[rowIndex][rowLength + propIndex] = cleanedUpText;
                        }
                        else {
                            const langItems = propData[languages[propIndex]];
                            const langItemsNormalised = Array.isArray(langItems) ? langItems : [langItems];
                            langItemsNormalised.sort().forEach((dataValue, dataValueIndex) => {
                                // Escape certain characters
                                const cleanedUpText = escapeText(dataValue, format);
                                rowsWithContent[rowIndex + dataValueIndex][rowLength + propIndex] = cleanedUpText;
                            });
                        }
                    }
                    else {
                        const cleanedUpText = typeof propData === "string" ?
                            escapeText(propData, format)
                            :
                            propData;
                        rowsWithContent[rowIndex][rowLength + propIndex] = cleanedUpText;
                    }
                }
            });
        });
        return rowsWithContent;
    }

    function escapeText(text, format) {
        if (!text) return "";
        text = text.replace(/\\/g, '\\\\');
        // We only escape newlines in TSV output
        if (format === "tsv") text = text.replace(/\n/g, "\\n");
        text = text.replace(/\t/g, "\\t");
        text = text.replace(/\r/g, "\\r");
        return text;
    }

    function computeDisplayName(iri, options) {
        const objectProperties = options.objectProperties;
        const datatypeProperties = options.datatypeProperties;
        const additionalProperties = options.associations || [];
        const dp = Object.keys(datatypeProperties).find(prop => datatypeProperties[prop].iri === iri);
        if (dp !== undefined) {
            return datatypeProperties[dp] ?
                datatypeProperties[dp].displayName
                :
                iri;
        }
        const op = Object.keys(objectProperties).find(prop => objectProperties[prop].iri === iri);
        if (op !== undefined) {
            return objectProperties[op] ?
                objectProperties[op].displayName
                :
                iri;
        }
        const ap = additionalProperties.find(prop => prop.iri === iri);
        if (ap !== undefined && ap.label && ap.label[options.defaultLang]) {
            return Array.isArray(ap.label[options.defaultLang]) ?
                ap.label[options.defaultLang][0]
                :
                ap.label[options.defaultLang];
        }
        return iri;
    }

    function computeFinalRows(data, rows, options, template, resourceName = "Concept", format = "tsv") {

        const includeHeaderRow = template.tsvTemplateOption
            && template.tsvTemplateOption.includes("https://grafsync.graphifi.com/schema/tsv/includeheader");
        const referencesAsLabels = template.tsvTemplateOption
            && template.tsvTemplateOption.includes("https://grafsync.graphifi.com/schema/tsv/referencesAsLabels");
        let properties = [];
        let languages = [];
        template.tsvColumnProperty.forEach((prop, index) => {
            if (prop !== "https://grafsync.graphifi.com/schema/tsv/hierarchy" &&
                prop !== "https://grafsync.graphifi.com/schema/tsv/concepts" &&
                prop !== "https://grafsync.graphifi.com/schema/tsv/resources" &&
                prop !== "https://grafsync.graphifi.com/schema/tsv/IRI") {
                properties.push(prop);
                languages.push(template.tsvColumnLanguage[index]);
            }
        });

        let finalRows = rows;
        let headerRow = [resourceName + " IRI"];
        // To add columns for additional properties we need to know the longest row
        const maxDepth = rows.reduce((r, s) => Math.max(s.length, r), []);
        for (let i = 1; i < maxDepth; i++) { headerRow.push(resourceName + " (Level " + i + ")"); }

        // So we are adding columns for all non hierarchy/IRI columns (which we splice in later)
        if (properties && properties.length > 0) {
            for (let p = 0; p < properties.length; p++) {
                const prop = properties[p];
                const displayName = computeDisplayName(prop, options);
                headerRow.push(displayName);
            }
            // Pad out rows with cells to maximum width for hierarchy
            rows.forEach(row => {
                if (row.length < maxDepth) {
                    for (let i = row.length; i < maxDepth; i++) { row.push(null); }
                }
            });
            finalRows = computeAdditionalRows(data, rows, properties, languages, format, resourceName, referencesAsLabels);
        }

        if (includeHeaderRow) {
            finalRows.splice(0, 0, headerRow);
        }

        // Now we need to sort out hierarchies, IRIs and columns
        const withColumns = finalRows.map(row => {
            const columnRow = [];
            let propIndex = 0;
            template.tsvColumnProperty.forEach(cp => {
                if (cp === "https://grafsync.graphifi.com/schema/tsv/IRI") {
                    columnRow.push(row[0]);
                }
                else if (cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy"
                    || cp === "https://grafsync.graphifi.com/schema/tsv/concepts"
                    || cp === "https://grafsync.graphifi.com/schema/tsv/resources") {
                    const hr = row.slice(1, maxDepth);
                    columnRow.push.apply(columnRow, hr);
                }
                else {
                    columnRow.push(row[maxDepth + propIndex]);
                    propIndex++;
                }
            });
            return columnRow;
        });

        if (format === "tsv") {
            return withColumns.map(row => row.join("\t")).join("\n");
        }
        // We'll use SheetJS for XLSX and CSV
        return withColumns;
    }

    function tsvSchemeFunction(id, data, options, template, format) {

        // We sort by the first column that has a language value
        const langColumnIndex = template.tsvColumnProperty.findIndex(cp => cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy" || cp === "https://grafsync.graphifi.com/schema/tsv/concepts");
        const lang = langColumnIndex >= 0 ?
            template.tsvColumnLanguage[langColumnIndex]
            :
            options.defaultLang;
        const scheme = data.graph && data.graph.find(item => item.id === id);

        let rows = [];
        const resourceLookup = getResourcesFromData(data);
        if (scheme) {
            const sortProperty = "sortProperty" in options && template.tsvTemplateOption
                && template.tsvTemplateOption.includes("https://grafsync.graphifi.com/schema/tsv/useCustomSorting") ?
                options.sortProperty
                :
                null;
            sortConcepts(resourceLookup, scheme.hasTopConcept, lang, sortProperty, options.sortNumerically === true)
                .forEach(concept => {
                    let row = [concept];
                    //const conceptData = data.graph.find(item => item.id === concept);
                    const conceptData = resourceLookup[concept];
                    const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                        conceptData.prefLabel[lang]
                        :
                        'No value in selected language';
                    row.push(label);
                    rows.push(row);
                    if (conceptData && conceptData.narrower) processNarrower(rows, data, resourceLookup, conceptData, lang, [], 1, sortProperty, options.sortNumerically === true);
                });
        }
        const finalData = computeFinalRows(data, rows, options, template, "Concept", format);
        return finalData;
    }

    function tsvConceptFunction(id, data, options, template, format) {

        // We sort by the first column that has a language value
        const langColumnIndex = template.tsvColumnProperty.findIndex(cp => cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy" || cp === "https://grafsync.graphifi.com/schema/tsv/concepts");
        const lang = langColumnIndex >= 0 ?
            template.tsvColumnLanguage[langColumnIndex]
            :
            options.defaultLang;
        const concept = data.graph && data.graph.find(item => item.id === id);

        let rows = [];
        const resourceLookup = getResourcesFromData(data);
        if (concept) {
            const sortProperty = "sortProperty" in options && template.tsvTemplateOption
                && template.tsvTemplateOption.includes("https://grafsync.graphifi.com/schema/tsv/useCustomSorting") ?
                options.sortProperty
                :
                null;
            let row = [id];
            const conceptData = resourceLookup[id];
            const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                conceptData.prefLabel[lang]
                :
                'No value in selected language';
            row.push(label);
            rows.push(row);
            if (conceptData && conceptData.narrower) processNarrower(rows, data, resourceLookup, conceptData, lang, [], 1, sortProperty, options.sortNumerically === true);
        }
        const finalData = computeFinalRows(data, rows, options, template, "Concept", format);
        return finalData;
    }

    function tsvCollectionFunction(id, data, options, template, format) {

        // We sort by the first column that has a language value
        const langColumnIndex = template.tsvColumnProperty.findIndex(cp => cp === "https://grafsync.graphifi.com/schema/tsv/hierarchy" || cp === "https://grafsync.graphifi.com/schema/tsv/concepts");
        const lang = langColumnIndex >= 0 ?
            template.tsvColumnLanguage[langColumnIndex]
            :
            options.defaultLang;
        const collection = data.graph && data.graph.find(item => item.id === id);
        const memberProp = options.ordered ? "memberList" : "member";

        let rows = [];
        if (collection && collection[memberProp]) {
            let memberData = collection[memberProp];
            if (!options.ordered) {
                memberData.sort((a, b) => {
                    const aConcept = data.graph.find(item => item.id === a);
                    const bConcept = data.graph.find(item => item.id === b);
                    const aText = aConcept.prefLabel && aConcept.prefLabel[lang] ? aConcept.prefLabel[lang].toString().toLowerCase() : "";
                    const bText = bConcept.prefLabel && bConcept.prefLabel[lang] ? bConcept.prefLabel[lang].toString().toLowerCase() : "";
                    if (aText < bText) return -1;
                    return 1;
                });
            }
            memberData.forEach(concept => {
                let row = [concept];
                const conceptData = data.graph.find(item => item.id === concept);
                const label = conceptData && conceptData.prefLabel && conceptData.prefLabel[lang] ?
                    conceptData.prefLabel[lang]
                    :
                    'No value in selected language.\n';
                row.push(label);
                rows.push(row);
            });
        }

        const finalData = computeFinalRows(data, rows, options, template, "Concept", format);
        return finalData;
    }

    function tsvDatasetFunction(id, data, options, template, format) {

        // We sort by the first column that has a language value
        const langColumnIndex = template.tsvColumnProperty.findIndex(cp => cp === "https://grafsync.graphifi.com/schema/tsv/resources");
        const lang = langColumnIndex >= 0 ?
            template.tsvColumnLanguage[langColumnIndex]
            :
            options.defaultLang;
        const dataset = data.graph;
        let rows = [];
        if (dataset) {
            // Labels are included so we need to exclude those items
            const inDatasetResurces = dataset.filter(d => d.inDataset);
            const sortedResources = sortResource(inDatasetResurces, lang);
            sortedResources.forEach((resourceData) => {
                const label = resourceData && resourceData.label && resourceData.label[lang] ?
                    resourceData.label[lang]
                    :
                    'No value in selected language.\n';
                let row = [resourceData.id, label];
                rows.push(row);
            });
        }

        const finalData = computeFinalRows(data, rows, options, template, "Resource", format);
        return finalData;
    }

}

export default tsvExport;